// extracted by mini-css-extract-plugin
module.exports = {"logoHead":"LoginForm_logoHead__3ofMj","cooperative":"LoginForm_cooperative__ERUM4","main":"LoginForm_main__1lrmf","forgot":"LoginForm_forgot__3FSHe"};